<template>
  <crud-table
    :create-route="{
      name: 'operators.create',
    }"
    create-permission="create operator"
    :columns="fields"
    vuex-prefix="operator"
    create-role="Admin"
    fetch-address="operators"
    hide-developer-column
    hide-excel
  >
    <template #cell(actions)="data">
      <table-action-buttons
        fa-title="اپراتور"
        route="operators"
        :record-id="data.item.id"
        :delete-title="data.item.name"
        hidden-show-button
        permission="operator"
        role="Admin"
        @deleted="data.itemDeleted(data.itemDeleted(data.item))"
      >
      </table-action-buttons>
    </template>
  </crud-table>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        {
          key: "nameFa",
          sortable: true,
          label: "نام فارسی",
          thStyle: { width: "180px" },
          filter: {
            component: "SearchFilter",
            operator: "$lk",
            value: "",
          },
        },
        {
          key: "nameEn",
          sortable: true,
          label: "نام انگلیسی",
          thStyle: { width: "180px" },
          filter: {
            component: "SearchFilter",
            operator: "$lk",
            value: "",
          },
        },
      ],
    };
  },
};
</script>
